import { React, useEffect, useState, Fragment} from 'react';
// Material UI
import { Grid,Box,MenuItem,Select, TextField, Button, Container, } from '@mui/material';
//Components
// import { Dialog } from "@progress/kendo-react-dialogs";
import DialogTitle from '@mui/material/DialogTitle';


import Dialog from '@mui/material/Dialog';
import { toast } from "react-toastify";

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
// My components
import MyCard from '../../../shared/components/myCard'





//My Tools
// Custom Styles

const EditPopupForm = (props) => {
   
    
const defaultInputValues = {
    title: props.item.title,        
    sourceName:props.item.sourceName,
};

const validationSchema = Yup.object().shape({
    title: Yup.string().required('Başlık girilmesi gereklidir'),
    sourceName: Yup.string().required('Kaynak girilmesi gereklidir'),
});

const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
} = useForm({ defaultValues: defaultInputValues, resolver: yupResolver(validationSchema) });

const [isLoading, setIsLoading] = useState(false);


    const submitData = () => {
        props.onSubmit(props.item.id,getValues("title"), getValues("sourceName") );
    };

    
    return (
        <Container noValidate autoComplete="off" >
            <Dialog   title={`Güncellenen: ${"props.item.title"}`} open={props.openForm} onClose={props.cancelEdit}>


            <MyCard header="Tag Güncelle">
           <Box component="div" sx={{ pt: 1 ,width:250 }}>
                    <TextField fullWidth
                        required
                        id="outlined-required"
                        label="Başlık"                        
                        error={errors.title ? true : false}
                        helperText={errors.title?.message}
                        {...register('title')}
                        size="small"                       
                    />
                </Box>
                <Box component="div" sx={{ pt: 1 ,width:250 }}>
                    <TextField fullWidth
                        required
                        id="outlined-required"
                        label="Kaynak"                        
                        error={errors.sourceName ? true : false}
                        helperText={errors.sourceName?.message}
                        {...register('sourceName')}
                        size="small"
                       
                    />
                </Box>
                
                <Box component="div" sx={{ pt: 2 ,width:250 }}>
                    <Button fullWidth onClick={handleSubmit(submitData)} variant="outlined">Güncelle</Button>
                </Box>
                </MyCard>





            </Dialog>
        </Container>
    );
};

export default EditPopupForm;